import { LocalizationLanguage } from 'src/sb-tools/typescript/enums/localization-language.enum';
import { ClientField } from './client-field.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { FormApiCategory } from './form-api-category.model';

export class ClientForm {
    bigLogoLink: string;

    categories: FormApiCategory[];

    defaultFaqLink: string;

    facebookLink: string;

    faqLink?: string;

    faviconUrl: string;

    fields: ClientField[] = [];

    formSentMessage: string;

    googleAnalytics: string;

    googleTagManager: string;

    id: number;

    instagramLink: string;

    isChatEnabled: boolean;

    isCookieMessageHidden: boolean;

    isDefault: boolean;

    isHiddenCategoriesAllowed: boolean;

    isInternal: boolean;

    isSendFields?: boolean;

    isValuesFromUrlEnabled: boolean;

    hideBigLogo: boolean;

    hideLogo: boolean;

    language: LocalizationLanguage;

    logoLink: string;

    name: string;

    options: any; // Dictionary < string, string >

    rootCategory: FormApiCategory;

    twitterLink: string;

    type: FormType;
}
